import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Label } from 'synfrastructure';

class ReduxFormsField extends Component {
  render() {
    const { label, required, children, input, meta: { touched, error } } = this.props;

    const scaffoldClasses = {
      'input-scaffold': true,
      [`${this.props.className}`]: this.props.className,
    };

    const labelClasses = {
      input: true,
      'input--disabled': this.props.disabled,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        <Label className={classNames(labelClasses)}>
          {label ? (
            <span className="input-label">
              {label}
              {!required ? <span className="input-label--optional">optional</span> : null}
            </span>
          ) : (
            <span />
          )}
          {React.cloneElement(children, input)}
        </Label>
        {touched && error ? <div className="input-validation">{error}</div> : null}
      </div>
    );
  }
}

ReduxFormsField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
};

ReduxFormsField.defaultProps = {
  children: null,
  className: null,
  disabled: false,
  label: null,
  validation: null,
};

export default ReduxFormsField;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormsField.js